var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_346_5187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.91346C14.5903 8.6713 8 15.7391 8 24.3462C8 33.4589 15.3873 40.8462 24.5 40.8462C29.1427 40.8462 33.3371 38.9301 36.3369 35.8413L23.5571 25.5128C23.2048 25.228 23 24.7993 23 24.3462V7.91346ZM26 7.91346V22.8462H40.9327C40.2194 14.9305 33.9157 8.62678 26 7.91346ZM40.9328 25.8462H28.7424L38.2241 33.5093C39.7165 31.279 40.679 28.6656 40.9328 25.8462ZM5 24.3462C5 13.5766 13.7304 4.84619 24.5 4.84619C35.2696 4.84619 44 13.5766 44 24.3462C44 28.9886 42.3758 33.2557 39.6661 36.6044C36.0936 41.0192 30.6264 43.8462 24.5 43.8462C13.7304 43.8462 5 35.1157 5 24.3462Z",
    fill: "#222222"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_346_5187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(0.5 0.346191)",
    fill: "#602E9D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.91346C14.5903 8.6713 8 15.7391 8 24.3462C8 33.4589 15.3873 40.8462 24.5 40.8462C29.1427 40.8462 33.3371 38.9301 36.3369 35.8413L23.5571 25.5128C23.2048 25.228 23 24.7993 23 24.3462V7.91346ZM26 7.91346V22.8462H40.9327C40.2194 14.9305 33.9157 8.62678 26 7.91346ZM40.9328 25.8462H28.7424L38.2241 33.5093C39.7165 31.279 40.679 28.6656 40.9328 25.8462ZM5 24.3462C5 13.5766 13.7304 4.84619 24.5 4.84619C35.2696 4.84619 44 13.5766 44 24.3462C44 28.9886 42.3758 33.2557 39.6661 36.6044C36.0936 41.0192 30.6264 43.8462 24.5 43.8462C13.7304 43.8462 5 35.1157 5 24.3462Z",
    fill: "#602E9D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.0c09e155044bd14b8beb67e96f1adaa5.svg";
export { ForwardRef as ReactComponent };